import API from 'services/API';

export default function savePropertyObjectTitle(id, data) {
  const formData = new FormData();
  formData.append('newPseudonym', data.title);

  return API.request({
    method: 'POST',
    url: `/property/${id}/setPseudonym`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    mapper: (data) => {
      return data ? data : {};
    },
  });
}
